const enGB = {
  developer: "Developers",
  account: "Accounts",
};
export default enGB;
